var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStatusWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "System_symbol_warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sample",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-org-dashboard-0",
    transform: "translate(-1265.000000, -575.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(293.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(519.000000, 347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(20.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(216.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(19.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System_symbol_warning",
    transform: "translate(198.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9408945,12.5423739 C17.5853816,10.5699383 16.7957275,8.41242915 15.5781101,6.307638 C14.3604927,4.20228592 12.8839631,2.44072205 11.3501471,1.14688955 C9.98145075,-0.007296516 8.01798653,-0.007296516 6.64929018,1.14688955 C5.11547414,2.44072205 3.63950618,4.20228592 2.4224504,6.30707712 C1.20483299,8.41299 0.41461725,10.5699383 0.0591044161,12.5429348 C-0.257655832,14.3028161 0.723514656,16.0004455 2.40953287,16.6061408 C4.29886173,17.2858655 6.56448378,17.68125 8.99971868,17.68125 C11.4355151,17.68125 13.7011372,17.2853047 15.5910277,16.6061408 C17.2764842,15.9998847 18.2576547,14.3022554 17.9408945,12.5423739 Z",
    id: "Shape",
    fill: "#F66E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8,6.12728772 C7.8,5.54992926 8.33737155,5.08125 9,5.08125 C9.66262845,5.08125 10.2,5.54992926 10.2,6.12728772 L10.2,10.0346462 C10.2,10.6125707 9.66262845,11.08125 9,11.08125 C8.33737155,11.08125 7.8,10.6125707 7.8,10.0346462 L7.8,6.12728772 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9996958,14.68125 C8.3377947,14.68125 7.8,14.1437912 7.8,13.4815544 C7.8,12.8187088 8.3377947,12.28125 8.9996958,12.28125 C9.6628137,12.28125 10.2,12.8187088 10.2,13.4815544 C10.2,14.1437912 9.6628137,14.68125 8.9996958,14.68125 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatusWarning);
export default __webpack_public_path__ + "static/media/ic-status-warning.79871cc396a1850ebdce805ade759d06.svg";
export { ForwardRef as ReactComponent };